import React from 'react';
import classnames from 'classnames';
import { AvatarProps } from '../../types.d';

import styles from '../../Avatar.module.scss';

function SchoolCoachHappy({
  size,
  className,
}: Pick<AvatarProps, 'size' | 'className'>): JSX.Element {
  return (
    <svg
      className={classnames(className, {
        [styles[size]]: size,
      })}
      x="0px"
      y="0px"
      viewBox="0 0 144 144"
      enableBackground="new 0 0 144 143.9955139"
    >
      <g id="dice">
        <g id="happy_6_">
          <ellipse
            fill="#A6E3F9"
            cx="72"
            cy="71.9980164"
            rx="72"
            ry="71.9980164"
          />
          <g>
            <g>
              <defs>
                <ellipse
                  id="SVGID_33_"
                  cx="72"
                  cy="71.9980164"
                  rx="72"
                  ry="71.9980164"
                />
              </defs>
              <clipPath id="SVGID_2_">
                <use
                  xlinkHref="#SVGID_33_"
                  overflow="visible"
                />
              </clipPath>
              <g clipPath="url(#SVGID_2_)">
                <rect
                  x="4.0412374"
                  y="102.0339661"
                  transform="matrix(0.5534072 -0.8329108 0.8329108 0.5534072 -82.9684982 53.8037643)"
                  fill="#00AFEC"
                  width="9.2948923"
                  height="4.4749174"
                />
                <rect
                  x="75.253418"
                  y="-4.6626043"
                  transform="matrix(0.8660191 -0.500011 0.500011 0.8660191 10.3898983 38.7442436)"
                  fill="#00AFEC"
                  width="4.4748774"
                  height="9.2948093"
                />
                <rect
                  x="117.2213058"
                  y="120.2651291"
                  transform="matrix(0.8124476 -0.5830342 0.5830342 0.8124476 -50.42342 93.0760956)"
                  fill="#FFE502"
                  width="4.4747133"
                  height="9.2944689"
                />
                <rect
                  x="127.6950226"
                  y="54.7168388"
                  transform="matrix(0.8124476 -0.5830342 0.5830342 0.8124476 -10.2421579 86.8888931)"
                  fill="#FFE502"
                  width="4.4747133"
                  height="9.2944689"
                />
                <rect
                  x="9.4367104"
                  y="64.8112717"
                  transform="matrix(0.4565887 -0.8896779 0.8896779 0.4565887 -51.9982605 48.9656029)"
                  fill="#FFE502"
                  width="9.2952442"
                  height="4.4750867"
                />
                <rect
                  x="121.9701996"
                  y="73.2125931"
                  transform="matrix(0.7662011 -0.6426009 0.6426009 0.7662011 -20.9933434 98.019577)"
                  fill="#00AFEC"
                  width="4.4749694"
                  height="9.2950001"
                />
                <rect
                  x="16.9887295"
                  y="17.9291096"
                  transform="matrix(0.5534072 -0.8329108 0.8329108 0.5534072 -7.1343937 27.0272503)"
                  fill="#FFE502"
                  width="9.2948923"
                  height="4.4749174"
                />
                <rect
                  x="92.8075562"
                  y="17.9304676"
                  transform="matrix(0.5534072 -0.8329108 0.8329108 0.5534072 26.7246189 90.1781769)"
                  fill="#FFE502"
                  width="9.2948923"
                  height="4.4749174"
                />
                <rect
                  x="4.5767946"
                  y="40.372715"
                  transform="matrix(0.7662011 -0.6426009 0.6426009 0.7662011 -27.3368587 14.9045391)"
                  fill="#00AFEC"
                  width="4.4749694"
                  height="9.2950001"
                />
              </g>
            </g>
          </g>
          <g>
            <g>
              <defs>
                <ellipse
                  id="SVGID_35_"
                  cx="72"
                  cy="72.1966782"
                  rx="72"
                  ry="71.9979858"
                />
              </defs>
              <clipPath id="SVGID_4_">
                <use
                  xlinkHref="#SVGID_35_"
                  overflow="visible"
                />
              </clipPath>
              <g
                id="profil_10_"
                clipPath="url(#SVGID_4_)"
              >
                <g>
                  <path
                    fill="#FFE500"
                    d="M102.8176498,150.9079742c-10.7221069,5.57901-23.9722214,1.3947144-29.551239-9.3273926
                    c-5.57901-10.7221069-1.394722-23.972229,9.3273849-29.551239s23.972229-1.3947296,29.5512466,9.3273849
                    C117.811203,132.1660461,113.6269684,145.3289642,102.8176498,150.9079742z"
                  />
                  <path
                    fill="#FFE500"
                    d="M108.3966675,125.7153168l-5.3174591,109.1390228H23.2299213L17.912468,125.7153168
                    c-0.4358597-8.7171707,6.5378799-16.12677,15.342205-16.12677h59.9741402
                    C101.8587875,109.5885468,108.8325272,116.9109955,108.3966675,125.7153168z"
                  />
                  <ellipse
                    fill="#FFE500"
                    cx="33.4289703"
                    cy="131.468689"
                    rx="21.880085"
                    ry="21.880085"
                  />
                  <polygon
                    fill="#FFE500"
                    points="73.3536148,141.5805817 104.386734,206.1748199 134.0251312,194.2323303
                    113.8012695,125.3666611"
                  />
                  <polygon
                    fill="#FFE500"
                    points="41.5359344,151.8668365 -7.9776025,171.567688 -25.2376213,143.2368622
                    21.5735836,113.0754166"
                  />
                </g>
                <g id="default_11_">
                  <g>
                    <path
                      fill="#0E0E11"
                      d="M75.201828,61.7048645l-5.072113,0.3458099l-2.5360565-34.0060349l5.072113-0.3458099
                      c9.3372192-0.6916199,17.6370163,6.3401089,18.3287048,15.6773281l0,0
                      C91.6861649,52.8287697,84.6543655,61.0132446,75.201828,61.7048645z"
                    />
                    <path
                      fill="#7B4D42"
                      d="M53.8271255,110.634613c1.0460739,6.6250381,7.3224487,11.0708237,13.8603287,9.9375992
                      c6.5378799-1.1332169,11.0708237-7.3224411,9.9375992-13.860321
                      c-1.0460739-6.6250305-7.3224487-11.0708237-13.8603287-9.9375992
                      C57.2268448,97.8203583,52.7810555,104.0095825,53.8271255,110.634613z"
                    />
                    <polygon
                      fill="#7B4D42"
                      points="77.712204,106.7118912 53.8271255,110.634613 49.0326805,81.2577286 49.7300453,81.170578
                      72.9177551,77.3350067"
                    />
                    <path
                      fill="#7B4D42"
                      d="M64.287735,27.9086189l-1.8305855,0.2615032
                      c-11.8553352,1.9177895-19.875145,13.0757618-17.9573555,24.931097l6.6250305,40.3605042l22.4902954-3.6612244
                      c11.2451782-1.8305893,18.916275-12.4655457,17.08564-23.7978745l-3.5740204-21.7929344
                      C85.2961578,33.4876289,75.0970535,26.165184,64.287735,27.9086189z"
                    />
                    <ellipse transform="matrix(0.9984534 -0.0555948 0.0555948 0.9984534 -3.2968519 3.776602)" fill="#0E0E11" cx="66.2298889" cy="61.1438789" rx="1.6563616" ry="2.0922406" />
                    <ellipse transform="matrix(0.9984534 -0.0555948 0.0555948 0.9984534 -3.2313764 4.5605254)" fill="#0E0E11" cx="80.3523788" cy="60.3590279" rx="1.6563616" ry="2.0922406" />
                    <path
                      fill="#0E0E11"
                      d="M86.1450729,36.2841759c0.6108322,2.4869957-1.1489487,4.9300652-3.7013702,5.1385193
                      l-18.0350571,1.4728928c-0.4441452-0.0176468-0.819809,0.3952065-0.7513313,0.8256531
                      c0.3266716,4.2731247-2.7960625,7.9475594-6.98312,8.26054c-4.2731247,0.3266716-7.9475632-2.7960625-8.26054-6.98312
                      c-0.6766014-8.5777969,5.5774612-16.2474289,14.0417023-17.2789917
                      c0.4457397-0.0543232,0.8995018-0.0189495,1.3382034,0.0768299l18.8811836,4.1221848
                      c1.5509567,0.3386097,2.7740021,1.530386,3.1526489,3.0720577L86.1450729,36.2841759z"
                    />
                    <path
                      fill="#0E0E11"
                      d="M49.6321602,31.1200428l1.6379623-0.5500546l3.7259712,30.5001907
                      c0.3176117,2.8615723-0.9403572,5.482502-2.897583,5.7924843l-8.8581543,1.9226456L40.8440857,48.853569
                      C39.7599068,40.1031075,43.7127953,32.2280006,49.6321602,31.1200428z"
                    />
                    <path
                      fill="#7B4D42"
                      d="M45.109951,69.4023972l4.9687996-0.7845688l-0.784565-4.8815956
                      c-0.4358597-2.702301-2.9638596-4.5329399-5.753315-4.0970802l0,0
                      c-2.702301,0.4358559-4.5329399,2.9638596-4.0970802,5.7533112l0,0
                      C39.8796501,68.0076141,42.40765,69.8382568,45.109951,69.4023972z"
                    />
                    <path
                      fill="#FFFFFF"
                      d="M69.1693802,74.6326981c0.3487091,3.3125153,3.3997192,5.6661682,6.7122345,5.3174591
                      s5.6661682-3.3997192,5.3174591-6.7122345L69.1693802,74.6326981z"
                    />
                    <path
                      fill="#0E0E11"
                      d="M73.7563782,34.9174767l-12.1606483,1.6630745
                      c-3.1122818,0.4256744-9.7183838-1.0352707-11.4639511-2.7842979
                      c-1.6942558-1.6976089-4.8578186,0.8205566-3.702198-0.5047684
                      c3.1818047-3.6490707,7.0679016-6.3936844,10.7942162-7.5480328
                      c3.5119476-1.0879402,7.5928764-2.2479401,12.9638023-1.8631573
                      c6.2557907,0.4481754,15.0266266,1.8909206,15.8180389,6.3497047
                      C87.3448105,37.7748184,79.436615,34.1406059,73.7563782,34.9174767z"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
          <path
            fill="#0E0E11"
            d="M83.6240234,54.9980164c-0.0170288,0-0.0339966-0.0010071-0.0499878-0.0029907l-5.7139893-0.678009
            c-0.2319946-0.0280151-0.3989868-0.2380066-0.3709717-0.4710083c0.0269775-0.2330017,0.2520142-0.3959961,0.4699707-0.3710022
            l5.7139893,0.678009c0.2319946,0.0280151,0.3989868,0.2380066,0.3709717,0.4710083
            C84.019043,54.8399963,83.835022,54.9980164,83.6240234,54.9980164z"
          />
          <path
            fill="#0E0E11"
            d="M63.0109863,56.4840088c-0.1920166,0-0.3649902-0.1300049-0.4119873-0.3250122
            c-0.0549927-0.2269897,0.085022-0.4559937,0.3129883-0.5109863l6.0650024-1.4590149
            c0.2340088-0.0559998,0.4559937,0.0859985,0.5109863,0.3129883s-0.085022,0.4559937-0.3129883,0.5109863l-6.0650024,1.4590149
            C63.0770264,56.4810181,63.0430298,56.4840088,63.0109863,56.4840088z"
          />
          <path
            fill="#FFE500"
            d="M48.7340088,40.3560181c-0.2680054-1.0710144-1.1810303-32.1369934-1.1810303-32.1369934
            l19.401001,26.2479858L48.7340088,40.3560181z"
          />
        </g>
      </g>
    </svg>
  );
}

export default SchoolCoachHappy;
